import React from "react";
import ReactECharts from "echarts-for-react";

const IndusBenchMark2 = () => {
  const option = {
    title: {
      text: "Industry Benchmarking",
      left: "center",
      textStyle: {
        color: "#333",
        fontSize: 18,
        fontWeight: "bold",
      },
    },
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      bottom: 0,
      textStyle: {
        color: "#333",
      },
    },
    grid: {
      left: "3%",
      right: "4%",
      bottom: "10%",
      containLabel: true,
    },
    xAxis: {
      type: "value",
      axisLabel: {
        color: "#333",
      },
      max: 100, // Adjusted to 100% since we're using percentage data
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ccc", // Grid line color
          type: "dashed", // Dashed grid lines
        },
      },
    },
    yAxis: {
      type: "category",
      data: ["Cost Structure by Year", "Industry Cost Structure"],
      axisLabel: {
        color: "#333",
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: "#ccc", // Grid line color
          type: "dashed", // Dashed grid lines
        },
      },
    },
    series: [
      {
        name: "Wages",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [10, 15], // Updated Business & Industry Wages
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#4CAF50" }, // Base color
            { offset: 1, color: "#388E3C" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#2E7D32", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)", // Shadow for depth
          shadowBlur: 10,
          shadowOffsetX: 5, // Shadow offset for right side
          shadowOffsetY: 5, // Shadow offset for top side
        },
      },
      {
        name: "Purchases/COGS",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [78, 77], // Updated Business & Industry Purchases/COGS
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#1976D2" }, // Base color
            { offset: 1, color: "#1565C0" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#0D47A1", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
        },
      },
      {
        name: "Rent",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [1, 2], // Updated Business & Industry Rent
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#D32F2F" }, // Base color
            { offset: 1, color: "#B71C1C" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#C62828", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
        },
      },
      {
        name: "Utilities",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [0, 1], // Updated Business & Industry Utilities
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#9C27B0" }, // Base color
            { offset: 1, color: "#7B1FA2" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#6A1B9A", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
        },
      },
      {
        name: "Depreciation",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [0, 80], // Updated Business & Industry Depreciation
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#FFC107" }, // Base color
            { offset: 1, color: "#FFA000" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#FF8F00", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
        },
      },
      {
        name: "Other",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [4, 1], // Updated Business & Industry Other
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#FF5722" }, // Base color
            { offset: 1, color: "#E64A19" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#D84315", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
        },
      },
      {
        name: "Profit",
        type: "bar",
        stack: "total",
        emphasis: {
          focus: "series",
        },
        data: [7, 30], // Updated Business & Industry Profit
        color: {
          type: "linear",
          x: 0,
          y: 0,
          x2: 1,
          y2: 0,
          colorStops: [
            { offset: 0, color: "#2E7D32" }, // Base color
            { offset: 1, color: "#1B5E20" }, // Darker edge
          ],
        },
        itemStyle: {
          borderColor: "#1B5E20", // Darker border for 3D effect
          borderWidth: 2,
          shadowColor: "rgba(0, 0, 0, 0.5)",
          shadowBlur: 10,
          shadowOffsetX: 5,
          shadowOffsetY: 5,
        },
      },
    ],
    backgroundColor: "#fff",
  };

  return <ReactECharts option={option} style={{ height: "400px", width: "100%" }} />;
};

export default IndusBenchMark2;
